import AxiosChain from '@/packages/axios-chain'
import { message as $message } from 'ant-design-vue'
import selefToast from '@/components/mobile/Toast/index'
import store from '@/store'
import router from '@/router'
import { decode, getEncode } from '@/lib/mix'
import { apiDomain } from './config'
import { isMobile } from '@/lib/device'
import { setAuth, getLang, clearStorage } from '@/lib/storage'
import i18n from '@/lib/language'
import { filterWhite } from '@/lib/axios-white'

const chain = new AxiosChain()
chain
  .axiosConfig({
    withCredentials: false,
    baseURL: apiDomain
    // baseURL: '/mock'
  })
  .onRequest(config => {
    const { auth, pid, realbackAuth } = store.state
    const { url, baseURL } = config || {}
    const language = getLang()
    if (language) {
      config.headers['Language'] = language
    }
    if (baseURL.indexOf('open-weixin') !== -1) {
      config.headers['Authorization'] = realbackAuth
    } else if (auth) {
      config.headers['Authorization'] = auth
      // window.$sentry.setUser(store.state.auth, store.state.baseinfo)
    }
    if (pid && !filterWhite(url)) {
      config.headers['Project'] = pid
    }
    return config
  })
  .extendProto(proto => {
    proto.errorCommon = function (res = {}, raw = {}) {
      const config = this.getConfig()
      const { message } = res
      if (config.warn !== false) {
        if (isMobile) {
          selefToast({ type: 'error', text: message || i18n.t('message["115"]') })
        } else {
          // 防止自定义弹框后弹出两个错误提示框
          if (!config.selfTip) {
            $message.destroy()
            $message.error(message)
          }
        }
        // window.$sentry.log(res, { ...raw, type: 'info' })
      }
    }
    proto.error101 = async function (res) {
      // this.errorCommon(res)
      await new Promise(resolve => {
        store.commit('setAuth', '')
        setAuth('')
        store.commit('setRealbackAuth', '')
        clearStorage('realbackAuth')
        router.push('/account/login')
      })
    }
    proto.error102 = function (res) {
      const { payload } = res
      const form = this.getForm()
      if (form) {
        const fields = {}
        payload.forEach(({ field, message }) => {
          fields[field] = {
            errors: [new Error(message)]
          }
        })
        form.setFields(fields)
      }
    }
    proto.error103 = async function (res, raw) {
      await new Promise(async resolve => {
        const { message } = res || {}
        if (message === '项目已经被关闭') {
          const { pid } = store.state
          if (isMobile) {
            router.push(`/project/${pid}/m-404`)
          } else {
            router.push(`/project/${pid}/404`)
          }
        } else {
          await this.errorCommon(res, raw)
        }
      })
    }
  })
  .onNetFail(async function (error) {
    if (isMobile) {
      selefToast({ type: 'error', text: i18n.t('message["1251"]') })
    } else {
      $message.destroy()
      $message.error(i18n.t('message["311"]'))
    }

    // window.$sentry.log(error)
    console.error(error)
  })
  .onNetSuccess(async function (raw) {
    const res = raw.data
    const { error } = res
    const config = this.getConfig()
    if (res.error === undefined && res.code === 404) {
      // window.$sentry.log(res, { ...raw, type: 'error' })
    }
    if (error === 101) {
      if (config.error101) {
        await config.error101.call(this, res)
      } else if (typeof config.error101 === 'undefined') {
        await this.error101(res)
      }
    } else if (error === 102) {
      if (config.error102) {
        await config.error102.call(this, res)
      } else if (typeof config.error102 === 'undefined') {
        await this.error102(res)
      }
    } else if (error) {
      const codeHandle = config[`error${error}`]
      if (codeHandle) {
        await codeHandle.call(this, res)
      } else if (typeof codeHandle === 'undefined') {
        if (config.error) {
          await config.error.call(this, res)
        } else if (typeof config.error === 'undefined') {
          await this.errorCommon(res, raw)
        }
      }
    } else if (!error) {
      if (config.tip !== false && res.message) {
        if (isMobile) {
          selefToast({ type: 'success', text: res.message })
        } else {
          $message.destroy()
          $message.success(res.message)
        }
      }
    }
  }, 'common')
  .extend(rest => {
    rest.encode = func => {
      rest.onRequest(async config => {
        const encode = await getEncode()
        const params = await func.apply(rest, [rest.getParams(), encode])
        rest.params(params)
        return config
      }, '#900')
      return rest
    }
    rest.decode = func => {
      rest.onResponse(async response => {
        const { data } = response
        if (!data.error) {
          data.payload = await func.apply(rest, [data.payload, decode])
        }
        return response
      }, '#100')
      return rest
    }
    rest.onSuccess = func => {
      rest.onNetSuccess(async raw => {
        const res = raw.data
        if (!res.error) {
          await func.apply(rest, [res.payload, res, raw])
        }
      }, '#900')
      return rest
    }
    rest.onFail = func => {
      rest.onNetSuccess(async raw => {
        const res = raw.data
        if (res.error) {
          await func.apply(rest, [res.error, res, raw])
        }
      }, '#900')
      return rest
    }
    rest.onComplete = func => {
      rest.onNetSuccess(async raw => {
        const res = raw.data
        await func.apply(rest, [res, raw])
      })
      return rest
    }
  })
  .extend(rest => {
    rest._extendForm = null
    rest.setForm = form => {
      rest._extendForm = form
      return rest
    }
    rest.getForm = () => {
      return rest._extendForm
    }
  })
  .onNetSuccess(raw => {
    const res = raw.data
    if (!res.error && res.baseinfo) {
      store.commit('setBaseinfo', res.baseinfo)
      // window.$sentry.setUser(store.state.auth, store.state.baseinfo)
    }
  })
export default chain
